import { mdlStatus } from "./CompAttachmentsMdl";
import { mdlChangeInGeneralInfo } from "./mdlGetChangeInGeneralInfoRes";

export class mdlGetTravelDetailsAddEndorsemenRes {
    GeneralInfo: mdlChangeInGeneralInfo = new mdlChangeInGeneralInfo();
    st: mdlStatus = new mdlStatus();
    PassengerDetails: mdlPolicyPassengerDetails[] = [];
}

export class mdlPolicyPassengerDetails {
    PolicyNo: string = "";
    Name: string = "";
    // DOB: string | Date = "";

    
    Sex: string = "";
    PassportNo: string = "";
    IdentityNo: string = "";
    Nationality: any = null;
    Age: number = 0;
    RelationshipCode: any = null;
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetTravelDetailsAddEndorsemenRes.ts